export enum SignInRoutes {
  LOGIN_PATH = '/sign-in/login',
  VERIFY_OTP = '/sign-in/verify/otp',
  VERIFY_CP = '/sign-in/verify/carrier-pin',
  VERIFY_PASSWORD = '/sign-in/verify/password',
  CREATE_PASSWORD = '/sign-in/create-password',
  FORGOT_PASSWORD = '/sign-in/forgot-password',
  EXPIRED_LINK = '/sign-in/link-expired',
  RESET_SENT = '/sign-in/reset-sent',
  RESECURE = '/sign-in/resecure',
  MAX_ATTEMPTS = '/sign-in/max-attempts',
  NO_PLANS = '/sign-in/no-plans',
  VERIFY_LAST_NAME_POSTAL_CODE = '/sign-in/verify/last-name-postal-code',
  PHONE_CP = '/sign-in/phone-cp',
  VERIFY_METHOD = '/sign-in/verify',
  PLANS = '/sign-in/plans',
  BUSINESS_VALIDATION = '/sign-in/verify/business',
}

export enum EmailRoutes {
  EMAIL_ENTRY = '/email/entry',
  VERIFY_OTP = '/email/verify-otp',
}

export enum CommonRoutes {
  REDIRECTING = '/common/redirecting',
  ERROR = '/common/error-page',
  CUSTOM404 = '/common/404',
  NO_SESSION = '/common/no-session',
}

export enum StepUpRoutes {
  STEP_UP = '/step-up',
  MAX_ATTEMPTS = '/step-up/max-attempts',
  VERIFY_OTP = '/step-up/verify/otp',
  VERIFY_CP = '/step-up/verify/carrier-pin',
  PHONE_CP = '/step-up/phone-cp',
  NO_PLANS = '/step-up/no-plans',
  VERIFY_METHOD = '/step-up/verify',
  VERIFY_LAST_NAME_POSTAL_CODE = '/step-up/verify/last-name-postal-code',
  PLANS = '/step-up/plans',
}
